import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ArvrServicesParentpage.css";

import Arvr from "../../assests/ArServicesImg/Arvr-Asset.svg";
import heroImg from "../../assests/Background-img.svg";

// Components
import ARVRSecondpage from "../../components/Ar-vrServicespage/ARVRSecondpage";
import ARVRDevelopment from "./ARVRDevelopment";
import XyloiteARVR from "./XyloiteARVR";
import ArBusiness from "./ArBusiness";
import ContactFormModal from "../header/ContactFormModal";
import WhyIOTSection from "../WhyIOTSection/WhyIOTSection";
import { useNavigate } from "react-router-dom";
// Define service type
type Service = {
  id: string;
  title: string;
  icon: string;
  items: string[];
  hasRoute: boolean;
  routePath?: string;
};

const ArvrServicesParentpage: React.FC = () => {
  const navigate = useNavigate();
  const [activeService] = useState("ar");
    const [showContactForm, setShowContactForm] = useState(false);

  const handleServiceClick = (service: Service) => {
    if (service.hasRoute && service.routePath) {
      window.location.href = service.routePath;
    }
  };

  return (
    <div className="arvr-services-page">
      {showContactForm && <ContactFormModal onClose={() => setShowContactForm(false)} />}
      {/* Hero Section */}
<section
  className="arvr-hero-section d-flex align-items-center justify-content-center"
  style={{
    backgroundImage: `url(${heroImg})`,
    backgroundSize: "cover",
  }}
>
  <div className="container-arvr text-center">
    <h1 className="arvr-hero-title">Extended Reality (AR/VR)</h1>
    <p className="arvr-hero-subtitle">
      Elevate experiences with immersive AR/VR solutions for training, collaboration, and visualization.
    </p>
    <button
      className=" arvr-hero-button"
      onClick={() => navigate("/Contact-Us")}
    >
      Get in Touch
    </button>
  </div>
</section>

      {/* Other Sections */}
      <ARVRSecondpage />
      <ARVRDevelopment />
      <WhyIOTSection />
      <ArBusiness />
    </div>
  );
};

export default ArvrServicesParentpage;
